var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSinfin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4336",
    "data-name": "Group 4336",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.926,
    height: 27.794,
    viewBox: "0 0 24.926 27.794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #002e6b;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_733",
    "data-name": "Rectangle 733",
    className: "cls-1",
    width: 24.925,
    height: 27.794
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1215",
    "data-name": "Group 1215",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    className: "cls-1",
    d: "M12.585,33.178a.379.379,0,0,1-.154-.032L.725,27.934a.378.378,0,0,1,0-.69l11.706-5.211a.382.382,0,0,1,.307,0l11.707,5.211a.378.378,0,0,1,0,.69L12.738,33.145a.373.373,0,0,1-.153.032M1.807,27.589l10.778,4.8,10.779-4.8-10.779-4.8Z",
    transform: "translate(-0.123 -5.384)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    className: "cls-1",
    d: "M28.462,22.583a.388.388,0,0,1-.153-.032L16.224,17.188A.379.379,0,0,1,16,16.842V.377A.376.376,0,0,1,16.172.06a.381.381,0,0,1,.359-.029L28.616,5.394a.378.378,0,0,1,.224.345V22.2a.379.379,0,0,1-.378.378M16.755,16.6l11.329,5.027V5.985L16.755.958Z",
    transform: "translate(-3.915 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    className: "cls-1",
    d: "M.378,22.583a.38.38,0,0,1-.205-.061A.376.376,0,0,1,0,22.2V5.739a.379.379,0,0,1,.224-.345L12.309.032a.378.378,0,0,1,.531.345V16.842a.379.379,0,0,1-.224.345L.531,22.55a.388.388,0,0,1-.153.032m.378-16.6V21.624L12.085,16.6V.958Z",
    transform: "translate(0 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSinfin);
export default __webpack_public_path__ + "static/media/Icon_sinfin.f7bed5c78ec52e15757bc35aaed9cec8.svg";
export { ForwardRef as ReactComponent };